///////////////////////////////////// 
// TOP tab collection
/////////////////////////////////////

(() => {
  const ROOT_SELECTOR = '[data-tabs-collections]';

  const initOne = (root) => {
    if (!root || root.dataset.tabsInit === '1') return;

    const tabs = root.querySelectorAll('[role="tab"][data-tab]');
    const panels = root.querySelectorAll('[role="tabpanel"][data-panel]');
    if (!tabs.length || !panels.length) return;

    const activate = (tabId) => {
      tabs.forEach((t) => {
        const isActive = t.getAttribute('data-tab') === tabId;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((p) => {
        const isActive = p.getAttribute('data-panel') === tabId;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    tabs.forEach((t) => {
      t.addEventListener('click', () => {
        const tabId = t.getAttribute('data-tab');
        if (!tabId) return;
        activate(tabId);
      });
    });

    root.dataset.tabsInit = '1';

    const activeBtn = root.querySelector('[role="tab"].is-active[data-tab]');
    const initialTab = activeBtn ? activeBtn.getAttribute('data-tab') : (tabs[0].getAttribute('data-tab') || '');
    if (initialTab) activate(initialTab);
  };

  const initAll = (scope) => {
    const rootList = (scope || document).querySelectorAll(ROOT_SELECTOR);
    if (!rootList.length) return;
    rootList.forEach(initOne);
  };

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
})();



///////////////////////////////////// 
// サンクスページ
/////////////////////////////////////
(() => {
  const THANKS_URL = "/pages/atelier-u-thanks";
  const FLAG_KEY = "atelieru_register_just_submitted";

  const isThanksPage = () => location.pathname === THANKS_URL;
  const isAccountPage = () =>
    location.pathname === "/account" || location.pathname === "/account/";
  const isRegisterPage = () => location.pathname === "/account/register";

  const markJustSubmitted = () => {
    try {
      sessionStorage.setItem(FLAG_KEY, "1");
    } catch (e) {}
  };

  const clearFlag = () => {
    try {
      sessionStorage.removeItem(FLAG_KEY);
    } catch (e) {}
  };

  const hasFlag = () => {
    try {
      return sessionStorage.getItem(FLAG_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  const registerForm = document.querySelector("#create-customer form");
  if (registerForm) {
    registerForm.addEventListener("submit", () => {
      markJustSubmitted();
    });
  }

  // 登録失敗（既登録メール等）で /account/register に戻ってきた場合はフラグをクリア
  if (isRegisterPage() && hasFlag()) {
    clearFlag();
    return;
  }

  if (isAccountPage() && hasFlag()) {
    clearFlag();
    location.replace('/account/register?error=already_registered');
    return;
  }

  if (isThanksPage()) {
    clearFlag();
  }
  })();



///////////////////////////////////// 
// SHOPPING GUIDE
/////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const detailsList = document.querySelectorAll('.riu-acc');

  detailsList.forEach((details) => {
    const summary = details.querySelector('.riu-acc__summary');
    const content = details.querySelector('.riu-acc__content');
    if (!summary || !content) return;

    content.style.overflow = 'hidden';

    if (details.open) {
      content.style.height = 'auto';
    } else {
      content.style.height = '0px';
    }

    details.addEventListener('toggle', () => {
      if (!details.open) return;

      content.style.height = '0px';
      const target = content.scrollHeight;

      requestAnimationFrame(() => {
        content.style.transition = 'height 220ms ease';
        content.style.height = `${target}px`;
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        content.style.height = 'auto';
      };
      content.addEventListener('transitionend', onEnd);
    });

    summary.addEventListener('click', (e) => {
      if (!details.open) return;

      e.preventDefault();

      const current = content.getBoundingClientRect().height;
      content.style.height = `${current}px`;

      requestAnimationFrame(() => {
        content.style.transition = 'height 220ms ease';
        content.style.height = '0px';
      });

      const onEnd = (ev) => {
        if (ev.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        details.open = false;
      };
      content.addEventListener('transitionend', onEnd);
    });
  });
});



///////////////////////////////////// 
// 再入荷通知ボタンを移動
/////////////////////////////////////

(function () {
  function moveRestockBtn() {
    var restockBtn = document.getElementById('_ngc_stock_notice_btn');
    var atcWrapper = document.querySelector('.quantity-submit-row__submit');

    if (restockBtn && atcWrapper) {
      atcWrapper.insertAdjacentElement('afterend', restockBtn);
      return true;
    }
    return false;
  }

  if (!moveRestockBtn()) {
    var observer = new MutationObserver(function () {
      if (moveRestockBtn()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();